import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceRequirementGroup} from './service-requirement-group.model';

export const loadServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Load ServiceRequirementGroups',
  props<{ serviceRequirementGroups: ServiceRequirementGroup[] }>()
);

export const addServiceRequirementGroup = createAction(
  '[ServiceRequirementGroup/API] Add ServiceRequirementGroup',
  props<{ serviceRequirementGroup: ServiceRequirementGroup }>()
);

export const upsertServiceRequirementGroup = createAction(
  '[ServiceRequirementGroup/API] Upsert ServiceRequirementGroup',
  props<{ serviceRequirementGroup: ServiceRequirementGroup }>()
);

export const addServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Add ServiceRequirementGroups',
  props<{ serviceRequirementGroups: ServiceRequirementGroup[] }>()
);

export const upsertServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Upsert ServiceRequirementGroups',
  props<{ serviceRequirementGroups: ServiceRequirementGroup[] }>()
);

export const updateServiceRequirementGroup = createAction(
  '[ServiceRequirementGroup/API] Update ServiceRequirementGroup',
  props<{ serviceRequirementGroup: Update<ServiceRequirementGroup> }>()
);

export const updateServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Update ServiceRequirementGroups',
  props<{ serviceRequirementGroups: Update<ServiceRequirementGroup>[] }>()
);

export const deleteServiceRequirementGroup = createAction(
  '[ServiceRequirementGroup/API] Delete ServiceRequirementGroup',
  props<{ id: string }>()
);

export const deleteServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Delete ServiceRequirementGroups',
  props<{ ids: string[] }>()
);

export const clearServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Clear ServiceRequirementGroups'
);

// CUSTOM ACTIONS
export const createServiceRequirementGroupMutation = createAction(
  '[ServiceRequirementGroup/API] Create ServiceRequirementGroup',
  props<{ input: any }>()
);

export const updateServiceRequirementGroupMutation = createAction(
  '[ServiceRequirementGroup/API] Edit ServiceRequirementGroup',
  props<{ input: any }>()
);

export const getServiceRequirementGroups = createAction(
  '[ServiceRequirementGroup/API] Get ServiceRequirementGroups',
  props<{ filtering: { groupUniqueId: string,searchTerm:string,serviceUniqueId: string } }>()
);

export const deleteServiceRequirementGroupMutation = createAction(
  '[ServiceRequirementGroup/API] Remove ServiceRequirementGroup',
  props<{ requirementGroupUniqueId: string, id: string }>()
);

